import { api } from "@/services/api"
import { useMutation, useQueryClient } from "@tanstack/react-query"

interface UpdateDiagnosticStudySession {
  sessionId: string
  activityId: string
  answer?: string
  answerIndex?: number
  elapsedTimeInSeconds?: number
}

export default function useUpdateDiagnosticStudySession() {
  const queryClient = useQueryClient()
  const mutation = useMutation({
    mutationFn: ({ sessionId, activityId, ...data }: UpdateDiagnosticStudySession) => {
      return api.odin.activities.diagnostic.studySession.update(activityId, sessionId, data)
    },
    onSettled() {
      queryClient.invalidateQueries({
        queryKey: ["planner-get-weekly-objectives", "study-get-activities"],
      })
    },
  })

  return mutation
}
